/**
 * Celestia i18n barrel — board-game-client.
 *
 * Cloned from playground; UI is NOT shared (CLAUDE.md).
 * Default locale is ko-KR per the monorepo primary.
 */

import { enUS } from "./en-US";
import { koKR } from "./ko-KR";

export type LocaleCode = "ko-KR" | "en-US";

export const locales: Readonly<
  Record<LocaleCode, Readonly<Record<string, string>>>
> = {
  "ko-KR": koKR,
  "en-US": enUS,
};

export const DEFAULT_LOCALE: LocaleCode = "ko-KR";

export { enUS, koKR };
